import styled from 'styled-components';

export const StyledSyncMonitoring = styled.div`
    padding: 2rem;
`;
